export default __webpack_public_path__ + "static/media/ck.33fd135a.jpg";